import {createDatatableColumnRegistry} from "@/src/modules/core/lib/datatable-columns";

export const VEHICLE_CHECK_TABLE_COLUMN_IDS = [
  "created_at",
  "plate",
  "state",
  "recognition",
  "safelisting",
  "permanent_parking",
  "outside_perimeter",
  "outside_shift_properties",
  "outcome",
] as const;

export type VehicleCheckTableColumnId = (typeof VEHICLE_CHECK_TABLE_COLUMN_IDS)[number];

const COLUMN_DEFS = [
  {id: "created_at", label: "Created", defaultVisible: true},
  {id: "plate", label: "Plate", defaultVisible: true},
  {id: "state", label: "State", defaultVisible: true},
  {id: "recognition", label: "Recognition", defaultVisible: true},
  {id: "safelisting", label: "Safelisting", defaultVisible: true},
  {id: "permanent_parking", label: "Perm. parking", defaultVisible: true},
  {id: "outside_perimeter", label: "Outside perimeter", defaultVisible: true},
  {id: "outside_shift_properties", label: "Outside shift", defaultVisible: true},
  {id: "outcome", label: "Outcome", defaultVisible: true},
] as const satisfies readonly {id: VehicleCheckTableColumnId; label: string; defaultVisible: boolean}[];

export const vehicleChecksTableColumns = createDatatableColumnRegistry(
  VEHICLE_CHECK_TABLE_COLUMN_IDS,
  COLUMN_DEFS,
);

export const getOrderedVisibleVehicleCheckColumns =
  vehicleChecksTableColumns.getOrderedVisibleColumns;
